import script from "./ErrorAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&setup=true&lang=js"

import "./ErrorAlert.vue?vue&type=style&index=0&id=0c092176&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c092176"]])

export default __exports__